import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;
import { write } from 'xlsx';

axios.defaults.withCredentials = true;

export const get_services = async (serviceTypeIds) => {
    const res = await axios.post(`${API_URL}common/services`, {
        serviceTypeIds,
    });
    return res;
};
export const get_service_packages = async (serviceIds) => {
    const serviceId = serviceIds != undefined ? serviceIds : [];
    const res = await axios.post(`${API_URL}common/service-packages`, {
        serviceIds: serviceId,
    });
    return res;
};
export const get_Payment_Channels = async () => {
    const res = await axios.post(`${API_URL}common/payment-channels`);
    return res;
};
export const get_Transaction_Types = async () => {
    const res = await axios.post(`${API_URL}common/transaction-types`);
    return res;
};
export const get_platforms = async () => {
    const res = await axios.post(`${API_URL}common/platforms`);
    return res;
};
export const get_campaigns = async () => {
    const res = await axios.post(`${API_URL}common/campaigns`);
    return res;
};
export const get_Graphical_Statistics = async (values) => {
    const res = await axios.post(`${API_URL}revenue-report/graphical-statistics`, values);

    return res;
};
export const get_Data_Statistics = async (values) => {
    const res = await axios.post(`${API_URL}revenue-report/data-statistics`, values);
    return res;
};

export const _exportHistory = async (values) => {
    const response = await axios({
        url: `${API_URL}revenue-report/export-history`,
        method: 'POST',
        responseType: 'blob', // Quan trọng: Định dạng response là blob
        headers: {
            'Content-Type': 'application/json',
        },
        data: values,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const a = document.createElement('a');
    a.href = url;
    a.download = 'output.xlsx'; // Tên file muốn lưu
    document.body.appendChild(a);
    a.click();
    a.remove(); // Sau khi tải về, xóa element a khỏi DOM
};

export const get_metrics = async (type) => {
    const res = await axios.post(`${API_URL}common/metrics`, {
        type: type,
    });
    return res;
};
export const get_dimensions = async (type) => {
    const res = await axios.post(`${API_URL}common/dimensions`, {
        type: type,
    });
    return res;
};
export const get_Channels = async () => {
    const res = await axios.post(`${API_URL}common/channels`);
    return res;
};
export const get_order_statuses = async () => {
    const res = await axios.post(`${API_URL}common/order-statuses`);
    return res;
};
export const get_staffs = async () => {
    const res = await axios.post(`${API_URL}common/staffs`);
    return res;
};
export const get_call_numbs = async () => {
    const res = await axios.post(`${API_URL}common/call-numbs`);
    return res;
};
export const get_order_types = async () => {
    const res = await axios.post(`${API_URL}common/order-types`);
    return res;
};

export const get_rates = async () => {
    const res = await axios.post(`${API_URL}common/rates`);
    return res;
};

export const get_cauhois = async () => {
    const res = await axios.post(`${API_URL}common/cauhois`);
    return res;
};

export const getAppVersions = async () => {
    const res = await axios.post(`${API_URL}common/app-versions`);
    return res;
};

export const getOrderCallNotes = async () => {
    const res = await axios.post(`${API_URL}common/orderCallNotes`);
    return res;
};

export const getAudiences = async () => {
    const res = await axios.post(`${API_URL}common/audiences`);
    return res;
};

export const getPremiumOrderNotes = async () => {
    const res = await axios.post(`${API_URL}common/premiumOrderNotes`);
    return res;
};

export const getApiNames = async () => {
    const res = await axios.post(`${API_URL}common/apiNames`);
    return res;
};

export const getRelationNames = async () => {
    const res = await axios.post(`${API_URL}common/relationNames`);
    return res;
};

export const getCallNumbPerDay = async () => {
    const res = await axios.post(`${API_URL}common/call-numb-per-days`);
    return res;
};
